// src/components/SideNav.js
import React from 'react';
import { Link } from 'react-router-dom';

const SideNav = ({ userProfile, handleLogout }) => {
    return (
        <nav className="col-md-2 d-none d-md-block sidebar p-3"
        style={{ height: '100vh', overflow: 'auto', position: 'sticky', top: 0 }} 
        > {/* Style is for Sticky sidebar for better UX */}
            <h2 className="sidebar-heading text-center fw-bold fs-1">Menu</h2>
            <ul className="nav flex-column">
                <hr className="divider" />
                <li className="nav-item">
                    <Link className="nav-link text-dark text-center fw-bold fs-5" to="/dashboard"><span className="me-2">🏠</span>Dashboard</Link>
                </li>
                <hr className="divider" />
                <li className="nav-item">
                    <Link className="nav-link text-dark text-center fw-bold fs-5" to="/project"><span className="me-2">🔍</span>Project Analysis</Link>
                </li>
                <hr className="divider" />
                <li className="nav-item">
                    <Link className="nav-link text-dark text-center fw-bold fs-5" to="/outstaff"><span className="me-2">🤝</span>Outstaff Search</Link>
                </li>
                <hr className="divider" />
                {/* 
                <li className="nav-item">
                    <Link className="nav-link text-dark text-center fw-bold" to="/tasks">Tasks</Link>
                </li>
                <hr className="divider" />
                */}
                <li className="nav-item">
                    <Link className="nav-link text-dark text-center fw-bold fs-5" to="/team"><span className="me-2">🧑‍🤝‍🧑</span>Meet Digis</Link>
                </li>
                <hr className="divider" />
                <li className="nav-item">
                    <Link className="nav-link text-dark text-center fw-bold fs-5" to="/explore"><span className="me-2">🚀</span>Explore</Link>
                </li>
                <hr className="divider" />
                <li className="nav-item">
                    <Link className="nav-link text-dark text-center fw-bold fs-5" to="/contact"><span className="me-2">📞</span>SoS</Link>
                </li>
                <hr className="divider" />
                <li className="nav-item">
                    <Link className="nav-link text-dark text-center fw-bold fs-5" to="/profile"><span className="me-2">👤</span>Profile</Link>
                </li>
                <hr className="divider" />
                
            </ul>

            <div className="sidebar-user-info mt-4 text-center fw-bold fs-5">
                {userProfile && <p>Welcome, {userProfile.username}!</p>}
                <button 
                    onClick={handleLogout} 
                    className="btn btn-sm btn-danger fw-bold"
                >
                    Logout
                </button>
            </div>
        </nav>
    );
};

export default SideNav;
